import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const formatStatus = (val) => {
  switch (val) {
    case 'failed':
      return 'Failed'
    case 'succeeded':
      return 'Succeeded'
    default:
      return 'Unknown'
  }
}

const columns = [
  { title: 'Created', prop: 'created_at', format: 'dateWithTime' },
  { title: 'File Name', prop: 'csv_file_name' },
  { title: 'Uploaded by', prop: 'user_name', sortable: false },
  { title: 'Upload Status', prop: 'status', format: formatStatus }
]

const defaults = {
  order: [
    { column: 'created_at', direction: 'desc' }
  ]
}

const logHistory = (props) => (
  <List
    title='Log History'
    apiPath='admin/member_import_logs'
    columns={columns}
    filters={[]}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
    hideCreate
  />
)

export default logHistory
